import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { resolveViewerClockVariables } from "@common/helpers/report-variables";

interface UseReportChromeParams {
    chrome: ReportPresentationChrome;
    generationDate: Date;
}

export function useReportChrome({
    chrome,
    generationDate,
}: UseReportChromeParams): ReportPresentationChrome {
    const resolveClock = (text: string): string =>
        resolveViewerClockVariables(text, generationDate);

    return {
        header: resolveClock(chrome.header),
        title: resolveClock(chrome.title),
        subtitle: resolveClock(chrome.subtitle),
        subtitle2: resolveClock(chrome.subtitle2),
        footer: resolveClock(chrome.footer),
        memo: resolveClock(chrome.memo),
        watermarkText: resolveClock(chrome.watermarkText),
    };
}
